/**
 * Forces a file download by fetching the file and creating a blob URL
 * Works reliably across all modern browsers including Chrome
 * @param url - The URL of the file to download
 * @param fileName - Optional filename for the download (defaults to "download")
 */
export async function downloadFile(
  url: string,
  fileName?: string,
): Promise<void> {
  try {
    // First try the simple approach for same-origin files
    if (url.startsWith(window.location.origin) || url.startsWith("/")) {
      const link = document.createElement("a")
      link.href = url
      link.download = fileName || "download"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      return
    }

    // For cross-origin or problematic files, fetch and create blob
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)

    // Create download link with blob URL
    const link = document.createElement("a")
    link.href = blobUrl
    link.download = fileName || "download"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Clean up the blob URL
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error("Download failed:", error)
    // Fallback: open in new tab if download fails
    window.open(url, "_blank")
  }
}
